import PropTypes from "prop-types"
import React from "react"

import { connect } from "react-redux"
import { BrowserRouter as Router, Switch } from "react-router-dom"

// Import Routes all
import { authRoutes, userRoutes } from "./routes/allRoutes"

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware"

// layouts Format
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"
import VerticalLayout from "./components/VerticalLayout/"

// Import scss
import { ErrorModal } from "components/Common/Modals"
import "./assets/scss/custom.scss"
import "./assets/scss/theme.scss"
import { ToastContainer } from "react-toastify"
import SignalRNotifyCreateRequest from "pages/Laboratory/TestRequest/SignalRNotifyCreateRequest"

const App = props => {
  function getLayout() {
    let layoutCls = VerticalLayout
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }
  const Layout = getLayout()
  return (
    <React.Fragment>
      <ToastContainer
        newestOnTop
        pauseOnFocusLoss={false}
        icon={false}
      />
      <SignalRNotifyCreateRequest />
      <ErrorModal />
      <Router>
        <Switch>
          {authRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
              exact
            />
          ))}
          {userRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
              exact={route.exact}
              moduleId={route.moduleId}
            />
          ))}
          {/* <Redirect to={{ pathname: "/404" }} /> */}
        </Switch>
      </Router>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
